// Embroidery design files (.dst, .pes, …) live in their own PRIVATE bucket, apart from
// the public one that holds the photos. Nobody can open a link to a file there: a
// logged-in person asks Supabase for a signed link that works for a short while, and
// only then can the file be downloaded (see DownloadButton.jsx).
export const DESIGN_FILES_BUCKET = "design-files";

// How long a download link stays valid, in seconds.
export const DOWNLOAD_LINK_SECONDS = 60;
